<template>
  <v-dialog :value="chosenItem" max-width="800px" @click:outside="closeInfo">
    <v-card class="pa-4">
      <v-card-title class="pa-3">
        <div class="p-relative flex">
          <h2 v-if="infoDef" class="d-flex align-center text-h6">
            <span>{{ infoDef.topic }}</span>
            <v-icon>mdi-chevron-right</v-icon>
            <span>{{ infoDef.sub_topic }}</span>
          </h2>
          <v-icon class="close-button" @click="closeInfo">close</v-icon>
        </div>
      </v-card-title>
      <v-card-subtitle class="text-pre-wrap black--text ma-2 pa-0">
        {{ chosenItem.comments }}
      </v-card-subtitle>

      <!-- Localized content -->
      <template v-if="localizationLanguages.length > 0">
        <v-divider class="mx-2 my-2"></v-divider>

        <v-card-subtitle
          v-for="lang in localizationLanguages"
          :key="lang"
          class="text-pre-wrap black--text ma-2 pa-0 pt-2"
        >
          <div class="d-flex">
            <div
              class="d-inline-flex align-center mr-2 flex-shrink-0"
              style="min-width: 45px"
            >
              <country-flag
                :country="getLanguageCountry(lang)"
                :rounded="true"
                size="small"
              />
              <span class="text-caption grey--text ml-1">({{ lang }})</span>
            </div>
            <span class="flex-grow-1">{{
              chosenItem.localization[lang] || ''
            }}</span>
          </div>
        </v-card-subtitle>
      </template>

      <v-card-text v-if="!!chosenItemMedia" class="pa-0 mt-4">
        <gallery
          :thumbnails="true"
          :images="chosenItemMedia"
          :cols="4"
          :readonly="true"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import CommonFunctions from 'components/mixins/common_functions'
import PermissionsMixin from 'components/mixins/permissions-mixin'
import find from 'lodash/find'
import Gallery from 'components/common/gallery'
import cloneDeep from 'lodash/cloneDeep'
import CountryFlag from 'vue-country-flag'
import { LANGUAGES } from '@/consts'

export default {
  components: { Gallery, CountryFlag },
  mixins: [CommonFunctions, PermissionsMixin],
  computed: {
    chosenItemMedia() {
      const item = this.chosenItem
      if (item.movie_url) {
        let images = cloneDeep(item.images)
        images.push(item.movie_url)
        return images
      } else {
        return item.images
      }
    },
    chosenItem() {
      return this.$store.state.chosenInfoItem
    },
    localizationLanguages() {
      const item = this.chosenItem
      if (item?.localization) {
        return Object.keys(item.localization).filter(lang => lang !== 'en')
      }
      return []
    },
    infoDef() {
      if (this.$store.state.listingInfoDef) {
        return find(
          this.$store.state.listingInfoDef.listingInfoDefs,
          infoItemDef => {
            return infoItemDef.id === this.chosenItem.listing_info_def_id
          }
        )
      }
      return null
    },
  },
  methods: {
    closeInfo() {
      this.$store.commit('updateChosenInfoItem', null)
    },
    getLanguageName(langCode) {
      const language = LANGUAGES.find(lang => lang.lang === langCode)
      return language ? language.label : langCode.toUpperCase()
    },
    getLanguageCountry(langCode) {
      const language = LANGUAGES.find(lang => lang.lang === langCode)
      return language ? language.country : 'us'
    },
  },
}
</script>
